import React from 'react';
import { artKlasse, artLabel } from '../lib/rechnungsart';
import './RechnungsartDialoge.css';

/** Badge „Art“ einer Ausgangsrechnung (Rechnung, Abschlags-/Schlussrechnung, Gutschrift, Stornorechnung). */
const RechnungsartBadge: React.FC<{ art?: string | null }> = ({ art }) => (
  <span className={`rd-art rd-art--${artKlasse(art)}`}>{artLabel(art)}</span>
);

export default RechnungsartBadge;
